import React, { Component } from 'react';
import { Select, Spin } from 'antd';
import { getData, debounce } from '@util';
const Option = Select.Option;

//此组件可以当作
//单选  如果是枚举的data 需设置属性 data和onFocusGetData为true 如果是api的只需设置api 如果呆远程查询 需设置api 和 kw
//多选  参数同单选
class WuxiInputSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      dataSource: [], //下拉数据
    };
    this.handleOnSearch = debounce(this.handleOnSearch.bind(this), 500);
  }
  //输入框获得焦点的回调
  handleOnFocus = () => {
    const { onFocus, onfocusGetData, api, searchParams } = this.props;
    console.log(searchParams);
    if (onfocusGetData === true) {
      if (api && this.state.dataSource.length === 0) {
        this.setState({ loading: true });
        getData({ api, searchParams })
          .then(res => {
            if (res && (res.code === 200000 || res.code == 200000)) {
              this.setState({
                loading: false,
                dataSource: res.result,
              });
            }
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      }
    }
    onFocus && onFocus();
  };

  //被选中时调用，参数为选中项的 value (或 key) 值 function(string | number | LabeledValue, option: Option)
  handleOnselect = (value, option) => {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(option.props.formatVal);
    } else {
      return undefined;
    }
  };
  //文本框值变化时回调	,function(value: string)
  handleOnSearch = value => {
    const { onSearch, api, kw } = this.props;
    if (api && value && kw) {
      this.setState({ inputValue: value, loading: true, dataSource: [] });
      onSearch && onSearch(value);
      getData({
        api,
        searchParams: { [kw]: value },
      }).then(res => {
        if (res && (res.code === 200000 || res.code == 200000)) {
          this.setState({
            loading: false,
            dataSource: res.result,
          });
        }
      });
    }
  };
  renderItem = () => {
    let { dataSource } = this.state;
    const { renderValueObj, renderOptions, data, renderValue, renderLabel } = this.props;
    if (data) {
      dataSource = [...data];
    }
    return dataSource.map(item => (
      <Option
        key={item.id || item.key || item.code}
        title={
          renderLabel
            ? renderLabel(item)
            : renderOptions
            ? renderOptions(item)
            : (item.key || item.code) + '-' + (item.value || item.name)
        }
        formatVal={renderValueObj && renderValueObj(item)} //为了兼容主数据历史键值对格式而设计
        value={
          renderValue
            ? renderValue(item)
            : renderOptions
            ? renderOptions(item)
            : (item.key || item.code) + '-' + (item.value || item.name)
        }>
        {renderLabel
          ? renderLabel(item)
          : renderOptions
          ? renderOptions(item)
          : (item.key || item.code) + '-' + (item.value || item.name)}
      </Option>
    ));
  };

  render() {
    const {
      placeholder = '请搜索并选择',
      showSearch = true,
      allowClear = true,
      onfocusGetData,
      style,
      data,
      ...props
    } = this.props;
    const { loading, inputValue } = this.state;
    return (
      <Select
        {...props}
        onFocus={this.handleOnFocus}
        onSelect={this.handleOnselect}
        // onSelect={undefined}
        onSearch={onfocusGetData ? undefined : this.handleOnSearch}
        placeholder={placeholder}
        loading={loading}
        style={{ ...style, width: '100%' }}
        // filterOption={false}
        allowClear={allowClear}
        showSearch={showSearch}
        // getPopupContainer={(triggerNode) => triggerNode.parentNode}
        notFoundContent={
          loading ? (
            <Spin size="small" />
          ) : inputValue ? (
            '暂无数据'
          ) : onfocusGetData || data ? (
            '暂无数据'
          ) : (
            '请搜索'
          )
        }>
        {this.renderItem()}
      </Select>
    );
  }
}

export default WuxiInputSearch;
